import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export const checkIsCompact = async (): Promise<void> => {
  try {
    const response = await Tasks.calendar.getUserSettings();

    if (response) {
      Entities.calendar.setIsCompactViewEnabled(response.isCompact);
    }
  } catch {
    return;
  }
};
